import { components, useApi } from "@appretio/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateCubeMutation } from "../cubeMutationInvalidation";

type RenameDimInput = components["schemas"]["RenameDimInput"];

export function useRenameDim() {
  const apiClient = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: RenameDimInput) => {
      const response = await apiClient.POST("/v2/forecast/cubes/rename-dim", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in rename dimension response");
      }
      return response.data.result;
    },
    onSuccess: async () => {
      await invalidateCubeMutation(queryClient, { lifecycle: true });
    },
    meta: {
      errorMessage: "Failed to rename dimension"
    }
  });
}
